import { useStyleConfig } from '@tectonic/elemason-components';
import { ElemasonWidgetActionType } from '@tectonic/types';
import clsx from 'clsx';
import { Button } from '../../components';
import { useActionDispatch } from '../../hooks';
import { useAccessorValue } from '../../hooks/useAccessorValue';

import type { ElemasonSimilarProductsControlWidget } from '@tectonic/types';
import type { FC } from 'react';

interface ElemasonSimilarProductsControlWidgetProps {
  widget: ElemasonSimilarProductsControlWidget;
}

const SimilarProductsControlWidget: FC<
  ElemasonSimilarProductsControlWidgetProps
> = ({ widget: { data, config } }) => {
  const actionDispatch = useActionDispatch();

  if (!data?.slug) {
    return null;
  }

  const { slug: slugAccessor } = data;
  const slug = useAccessorValue(slugAccessor);

  const triggerShowSimilarProducts = () => {
    actionDispatch({
      type: ElemasonWidgetActionType.GLOBAL_DRAWER_OPEN,
      payload: {
        slug: 'similar-products',
        data: {
          slug,
        },
        entry: 'bottom',
        exit: 'bottom',
      },
    });
  };

  const { style, className } = useStyleConfig(config?.container ?? {});

  return (
    <div className={clsx('flex flex-col', className)} style={style}>
      <Button
        onClick={triggerShowSimilarProducts}
        config={config?.button}
        data={data.button}
      />
    </div>
  );
};

export { SimilarProductsControlWidget };
